export default class Permissions {
	constructor(container) {
		container.querySelectorAll('.permissions_template_container')
			.forEach(permissionsTemplateContainer => {
				new PermissionsTemplate(permissionsTemplateContainer);
			});

		container.querySelectorAll('.permission_container')
			.forEach(permissionContainer => {
				new Permission(permissionContainer);
			});
	}
}

class Permission {
	constructor(permissionContainer) {
		const permission = permissionContainer
			.querySelector('.permission_toggle');

		permission.addEventListener('change', () => {
			const isChecked = permission.checked;

			permissionContainer
				.querySelectorAll('.permission_container input')
				.forEach(
					subPermission => {
						if (subPermission !== permission) {
							subPermission.disabled = !isChecked;
						}

						// Uncheck children on parent uncheck
						if (!isChecked) subPermission.checked = false;
					}
				);
		});
	}
}

class PermissionsTemplate {
	constructor(permissionsTemplateContainer) {
		this.toggle = permissionsTemplateContainer
			.querySelector('.permissions_template_toggle');
		this.permissionsTemplateContainer = permissionsTemplateContainer;
		this.permissions = this.permissionsTemplateContainer
			.querySelectorAll('.permission_toggle');
		this.allInputs =
			this.permissionsTemplateContainer.querySelectorAll('input');

		this.updateTemplateCheckbox();

		this.toggle.addEventListener('change', () => {
			const isTemplateChecked = this.toggle.checked;

			this.allInputs.forEach(permission => {
				// To allow mass checking by clicking the parent template box
				if (!this.toggle.indeterminate)
					permission.checked = isTemplateChecked;

				// Set the disabled prop on boxes that requires parent checked
				if (permission.dataset.requiresParent) {
					permission.disabled = !isTemplateChecked;
				}

				permission.addEventListener('change', () => {
					this.updateTemplateCheckbox();
				});
			});
		});
	}

	// To correctly show checked status or the "-" symbol for template boxes
	updateTemplateCheckbox() {
		const checkedPermissionsCount = [...this.permissions]
			.filter(input => input.checked).length;

		let templateInputState = { checked: false, indeterminate: false };

		if (checkedPermissionsCount == this.permissions.length) {
		  templateInputState = { checked: true, indeterminate: false };
		} else if (checkedPermissionsCount > 0) {
		  templateInputState = { checked: false, indeterminate: true };
		}

		this.toggle.checked = templateInputState.checked;
		this.toggle.indeterminate = templateInputState.indeterminate;
	}
}
